import React from "react";
import Back from "./common/back/Back";

const AboutPage = () => {
  return (
    <section className="aboutHome">
      <Back title="About"/>
      <div className="container flexSB">
        <div className="left row">
          <img src="./images/about.webp" alt="" />
        </div>
        <div style={styles.container}>
          <div style={styles.content}>
            <h2 style={styles.heading}>
              Welcome to Our MERN Stack Live Classes!
            </h2>
            <p style={styles.description}>
              Join us for an immersive educational journey through the MERN
              (MongoDB, Express.js, React.js, Node.js) stack. Our daily live
              sessions from 7:00 to 8:30 will equip you with the skills needed
              for success.
              <br />
              <br />
              <b style={styles.subHeading}>
                Our curriculum consists of four comprehensive modules:
              </b>
              <ul style={styles.list}>
                <li>&#8226; HTML, CSS, Bootstrap</li>
                <li>&#8226; JavaScript and React</li>
                <li>&#8226; MongoDB and Express with Node.js</li>
                <li>&#8226; Data Structures and Algorithms (DSA)</li>
              </ul>
              <br />
              Alongside live classes, benefit from doubt clearing sessions and
              access to class recordings for review. After completing the
              4-month course, unlock placement assistance, resume building
              sessions, and connections with top companies.
              <br />
              <br />
              <b style={styles.subHeading}>Key features of our course:</b>
              <ul style={styles.list}>
                <li>&#8226; Daily LIVE classes with our mentor</li>
                <li>&#8226; Enrollment and Completion Certificates</li>
                <li>&#8226; Lifetime access to projects & class recordings</li>
              </ul>
              <br />
              Seize the opportunity to become a proficient MERN stack developer
              and advance your career!
            </p>
            {/* <p style={styles.price}>Price: 6000 INR</p> */}
          </div>
        </div>
      </div>
    </section>
  );
};

const styles = {
  container: {
    backgroundColor: "#f4f4f4", // Light background color
    color: "#333", // Dark text color
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  content: {
    textAlign: "left", // Align content to the left
    padding: "40px",
  },
  heading: {
    fontSize: "2.5rem",
    marginBottom: "20px",
    fontFamily: "Arial, sans-serif",
  },
  subHeading: {
    fontSize: "1.5rem", // Increase font size for subheadings
    marginBottom: "10px", // Adjust margin to separate subheadings from content
    fontFamily: "Arial, sans-serif",
  },
  description: {
    fontSize: "1.2rem",
    lineHeight: "1.6",
    marginBottom: "20px",
    fontFamily: "Arial, sans-serif",
  },
  list: {
    listStyleType: "none", // Remove default list style
    paddingLeft: "0", // Remove default left padding
    textAlign: "left", // Align list items to the left
    marginLeft: "0", // Align list to the left
  },
  price: {
    fontSize: "1.2rem",
    fontFamily: "Arial, sans-serif",
  },
};

export default AboutPage;
